import { useAuth } from '@/composables/Auth.ts';
import { useAuthStore } from '@/stores/AuthStore.ts';
import { Configuration } from '@/clients/v2';

import type { BaseAPI as BaseAPIV2 } from '@/clients/v2/base.ts';
import type { AxiosInstance } from 'axios';

async function initApi<T extends BaseAPIV2>(Api: {
  new (configuration?: Configuration, basePath?: string, axios?: AxiosInstance): T;
}): Promise<T | null> {
  const store = useAuthStore();
  const { logout } = useAuth();

  const access_token = await store.getAccessTokenFromRefreshToken();
  if (!access_token) {
    logout();
    return null;
  }

  const baseUrl = `${import.meta.env.VITE_API_URL}/api/v2`;
  const config = new Configuration();
  config.basePath = baseUrl;
  config.accessToken = access_token;
  const newApi = new Api(config);
  return newApi;
}

export default initApi;
